/** Layouts */
import BaseLayout from '@/views/rh/profil_participant/layouts/BaseLayout';
import ProfilLayout from '@/views/rh/profil_participant/layouts/ProfilLayout';
//import EditLayout from '@/views/rh/profil_participant/layouts/EditLayout';
//import ShowLayout from '@/views/rh/profil_participant/layouts/ShowLayout';

/** Pages */
import ProfilParticipant from '@/views/rh/profil_participant/pages/profil/ProfilParticipant';

/* Competence */
import Competence from '@/views/rh/profil_participant/pages/Competence';

/* Habilitation */
import Habilitation from '@/views/rh/profil_participant/pages/habilitation/List';

/* Evaluation */
import EvaluationList from '@/views/rh/profil_participant/pages/evaluation/List';
import EvaluationCreate from '@/views/rh/profil_participant/pages/evaluation/Create';
import EvaluationShow from '@/views/rh/profil_participant/pages/evaluation/Show';

export default [
  {
    path: '/rh/formation/session/profil/:profilId/:sprov/:prov',
    component: ProfilLayout,
    children: [
      {
        path: '',
        component: ProfilParticipant,
        name: 'rh_formation_session_profil',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'competence',
        component: Competence,
        name: 'rh_formation_session_profil_competence',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'habilitation',
        component: Habilitation,
        name: 'rh_formation_session_profil_habilitation',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'evaluation',
        component: BaseLayout,
        children: [
          {
            path: '',
            component: EvaluationList,
            name: 'rh_formation_session_profil_evaluation',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'create',
            component: EvaluationCreate,
            name: 'rh_formation_session_profil_evaluation-create',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },

          {
            path: 'show/:evaluationId',
            component: EvaluationShow,
            name: 'rh_formation_session_profil_evaluation-show',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
        ],
      },
    ],
  },
];
